import React from 'react'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import CloseIcon from '@mui/icons-material/Close'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import { getConnectionSegmentsPromise } from '../../actions/databaseActions'

class CreateMultiSegment extends React.Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "open": false,
            "dimensionName": "",
            "connectionId": "",
            "connectionName": "",
            "allConnectionIds": [],
            "dataSource": "",
            "leftItems": [],
            "rightItems": [],
            "checked": [],
            "loaded": false
        };
    }
    componentDidMount() {
        if (this.props.open !== undefined) {
            this.setState({ "open": this.props.open })
        }

        let dimensionName = this.props.dimensionName,
            connectionId = this.props.connectionId,
            dataSource = this.props.dataSource,
            allConnectionIds = this.props.allConnectionIds,
            connectionName = this.props.connectionName;

        this.getSegments(connectionId, allConnectionIds, dataSource, dimensionName, connectionName)
        this.setState({
            "dimensionName": dimensionName,
            "connectionId": connectionId,
            "allConnectionIds": allConnectionIds,
            "connectionName": connectionName,
            "dataSource": dataSource,
            "loaded": false
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.open !== undefined && this.props.open !== undefined && prevProps.open !== this.props.open) {
            this.setState({ "open": this.props.open })
        }

        if (prevProps.dimensionName !== this.props.dimensionName ||
            prevProps.connectionId !== this.props.connectionId ||
            prevProps.dataSource !== this.props.dataSource ||
            prevProps.connectionName !== this.props.connectionName ||
            (prevProps.allConnectionIds && prevProps.allConnectionIds.length !== this.props.allConnectionIds.length)) {
            this.getSegments(this.props.connectionId, this.props.allConnectionIds, this.props.dataSource, this.props.dimensionName, this.props.connectionName)
            this.setState({
                "dimensionName": this.props.dimensionName,
                "connectionId": this.props.connectionId,
                "allConnectionIds": this.props.allConnectionIds,
                "connectionName": this.props.connectionName,
                "dataSource": this.props.dataSource,
                "loaded": false
            })
        }
    }
    render() {
        if (this.state.loaded === true) {
            return <Dialog
                open={this.state.open}
                maxWidth={'md'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="create-multi-seg">
                <DialogTitle>
                    <CloseIcon onClick={() => this.handleClose()} className="closePoup" />
                    <div>Create Multi Level Segment For: {this.state.dimensionName}</div>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} justify="center" alignItems="center">
                        <Grid item>
                            <Paper style={{ "minHeight": "20px", "minWidth": "100px" }}>
                                <List dense component="div" role="list">
                                    {
                                        this.state.leftItems.map((item, index) => {
                                            const itemKey = `left-item-${index}`
                                            return (
                                                <ListItem key={itemKey} role="listitem" button onClick={() => this.handleToggle(item)}>
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            checked={this.state.checked.indexOf(item) !== -1}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': itemKey }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={itemKey} primary={item} />
                                                </ListItem>)
                                        })
                                    }
                                </List>
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Grid container direction="column" alignItems="center">
                                <Button variant="outlined" size="small" aria-label="move all right" onClick={this.handleRightClickAll}>≫</Button>
                                <Button variant="outlined" size="small" aria-label="move selected right" onClick={this.handleRightClick}>&gt;</Button>
                                <Button variant="outlined" size="small" aria-label="move selected left" onClick={this.handleLeftClick}>&lt;</Button>
                                <Button variant="outlined" size="small" aria-label="move all left" onClick={this.handleLeftClickAll}>≪</Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Paper style={{ "minHeight": "20px", "minWidth": "100px" }}>
                                <List dense component="div" role="list">
                                    {
                                        this.state.rightItems.map((item, index) => {
                                            const itemKey = `right-item-${index}`
                                            return (
                                                <ListItem key={itemKey} role="listitem" button onClick={() => this.handleToggle(item)}>
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            checked={this.state.checked.indexOf(item) !== -1}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': itemKey }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={itemKey} primary={item} />
                                                </ListItem>)
                                        })
                                    }
                                </List>
                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogContent>
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        disabled={this.state.rightItems.length < 2}
                        onClick={() => {
                            if (this.props.onNewMultiSegmentCreation) {
                                this.props.onNewMultiSegmentCreation(this.getRightHandedItems())
                            }
                            this.setState({ "open": false })
                        }}>Submit</Button>
                </DialogContent>
            </Dialog>;
        } else {
            return <Dialog
                open={this.state.open}
                maxWidth={'md'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle>
                    <CloseIcon onClick={() => this.handleClose()} className="closePoup" />
                    <div> Create Multi Level Segment For: {this.state.dimensionName}</div>
                </DialogTitle >
                <DialogContent>
                    <Grid container spacing={2} justify="center" alignItems="center">
                        <Grid item>
                            <Paper style={{ "minHeight": "20px", "minWidth": "100px" }}>
                                <p> Loading...</p>
                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>;
        }
    }
    //#endregion

    //#region Private Methods
    handleClose = () => {
        if (this.props.closeEvent) {
            this.props.closeEvent();
        }
        this.setState({ "open": false })
    }
    getSegments = (connectionId, allConnectionIds, alias, dimensionName, connectionName) => {
        if (alias !== "" && dimensionName !== "" && connectionId !== -1 && allConnectionIds) {
            getConnectionSegmentsPromise(connectionId, allConnectionIds, alias, dimensionName, connectionName).then((res) => {
                let segments = res["dimension"]["segments"]
                let leftItems = []
                segments.forEach(s => {
                    leftItems.push(s["alias"])
                })
                this.setState({ "leftItems": leftItems, "rightItems": [], "loaded": true })
            }).catch((exe) => { console.error(exe) })
        }
    }
    handleToggle = (value) => {
        let checked = this.state.checked
        let checkedValueIndex = checked.indexOf(value)

        if (checkedValueIndex === -1) {
            checked.push(value)
        } else {
            checked.splice(checkedValueIndex, 1)
        }

        this.setState({ "checked": checked })
    }
    handleRightClick = () => {
        let leftItems = this.state.leftItems, rightItems = this.state.rightItems, checked = this.state.checked
        let leftItemsToRemove = []

        // Get the items that are being removed from the left
        for (let i = leftItems.length; i >= 0; i--) {
            let value = leftItems[i]
            if (checked.indexOf(value) !== -1) {
                leftItemsToRemove.push(i)
                rightItems = rightItems.concat(value)
            }
        }

        // Remove from Left Items
        leftItemsToRemove.forEach(i => {
            leftItems.splice(i, 1)
        })

        this.setState({ "leftItems": leftItems, "rightItems": rightItems, "checked": [] })
    }
    handleRightClickAll = () => {
        let leftItems = this.state.leftItems, rightItems = this.state.rightItems

        leftItems.forEach(item => {
            rightItems = rightItems.concat(item)
        })

        this.setState({ "leftItems": [], "rightItems": rightItems, "checked": [] })
    }
    handleLeftClick = () => {
        let leftItems = this.state.leftItems, rightItems = this.state.rightItems, checked = this.state.checked
        let rightItemsToRemove = []

        // Get the items that are being removed from the left
        for (let i = rightItems.length; i >= 0; i--) {
            let value = rightItems[i]
            if (checked.indexOf(value) !== -1) {
                rightItemsToRemove.push(i)
                leftItems = leftItems.concat(value)
            }
        }

        // Remove from Left Items
        rightItemsToRemove.forEach(i => {
            rightItems.splice(i, 1)
        })

        this.setState({ "leftItems": leftItems, "rightItems": rightItems, "checked": [] })
    }
    handleLeftClickAll = () => {
        let leftItems = this.state.leftItems, rightItems = this.state.rightItems

        rightItems.forEach(item => {
            leftItems = leftItems.concat(item)
        })

        this.setState({ "leftItems": leftItems, "rightItems": [], "checked": [] })
    }
    getRightHandedItems = () => {
        let rightItems = this.state.rightItems
        return rightItems.join("|")
    }
    //#endregion
}

export default CreateMultiSegment